// The forest-dirt tileset's layout, shared by generation (forest_dirt_ground.ts) and the client's ground
// effects without importing the map builder into the browser. Mirrors packages/tools/src/dirt/gen.py;
// forest_dirt_ground.test.ts pins it against the packed atlas.
export const FOREST_DIRT_TILESET = "forest-dirt"
export const FOREST_DIRT_SOIL_PHASES = 16 // 4x4 cells of a 128px texture
export const FOREST_DIRT_EDGE_PHASES = 4 // 2x2 cells of a 64px texture
export const FOREST_DIRT_EDGE_START = 81 * FOREST_DIRT_SOIL_PHASES // 1296
export const FOREST_DIRT_TILE_COUNT = FOREST_DIRT_EDGE_START + 625 * FOREST_DIRT_EDGE_PHASES // 3796

/** The LPC dirt tile the forest-dirt templates paint on map1 (lpc-terrain position). */
export const LPC_DIRT_TILE = 100

/** The soil zones, by distance from the grass. */
export const FOREST_DIRT_ZONES = { edge: 0, pebbly: 1, core: 2 } as const

/** corners: [top-left, top-right, bottom-left, bottom-right] zones, each 0..2. */
export const forestDirtSoilTile = (x: number, y: number, corners: number[]): number =>
    (corners[0] + corners[1] * 3 + corners[2] * 9 + corners[3] * 27) * FOREST_DIRT_SOIL_PHASES + (y % 4) * 4 + (x % 4)

/** corners: [top-left, top-right, bottom-left, bottom-right] dirt tiles round each vertex, each 0..4. */
export const forestDirtEdgeTile = (x: number, y: number, corners: number[]): number =>
    FOREST_DIRT_EDGE_START + (corners[0] + corners[1] * 5 + corners[2] * 25 + corners[3] * 125) * FOREST_DIRT_EDGE_PHASES +
    (y % 2) * 2 + (x % 2)

const smooth = (t: number) => t * t * (3 - 2 * t)

/**
 * The soil zone at pixel (lx, ly) of a forest-dirt tile (position in the tileset): the zone its corners
 * weigh most there, as gen.py's soil_tile picks it (less its small noise jitter). Edge overlays are all
 * edge soil.
 */
export const forestDirtSoilZone = (position: number, lx: number, ly: number): number => {
    if (position >= FOREST_DIRT_EDGE_START) return FOREST_DIRT_ZONES.edge
    const code = Math.floor(position / FOREST_DIRT_SOIL_PHASES)
    const corners = [code % 3, Math.floor(code / 3) % 3, Math.floor(code / 9) % 3, Math.floor(code / 27)]
    const u = smooth((lx + 0.5) / 32), v = smooth((ly + 0.5) / 32)
    const weights = [(1 - u) * (1 - v), u * (1 - v), (1 - u) * v, u * v]
    const score = [0, 0, 0]
    corners.forEach((zone, i) => (score[zone] += weights[i]))
    return score.indexOf(Math.max(...score))
}
